var map = {
	"./Fellas.svg": 344,
	"./Gmail.svg": 2491,
	"./Google.svg": 9310,
	"./Whatsapp.svg": 4785,
	"./carbohydrate.svg": 559,
	"./fruit.svg": 7447,
	"./protein.svg": 6772,
	"./vegetable.svg": 7956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;